import { setUiPreferences, useUiPreferences } from '../lib/useUiPreferences';

export default function GuideViewControls({ guideHidden }: { guideHidden: boolean }) {
  const ui = useUiPreferences();
  return <div className="guide-view-toolbar" role="group" aria-label="Guide und Bühne">
    <button data-ai-id="guide-collapse" aria-expanded={!guideHidden} aria-controls="guide-dock-content"
      aria-label={guideHidden ? 'Guide öffnen' : 'Guide einklappen'} title={guideHidden ? 'Guide öffnen' : 'Guide einklappen'}
      onClick={() => setUiPreferences({ guideCollapsed: !guideHidden, focus: false })}>{guideHidden ? '▸' : '◂'} Guide</button>
    <button data-ai-id="guide-coach-collapse" aria-expanded={!ui.coachHidden} aria-controls="guide-coach-content"
      aria-label={ui.coachHidden ? 'Kanzler öffnen' : 'Kanzler einklappen'} title={ui.coachHidden ? 'Kanzler öffnen' : 'Kanzler einklappen'}
      onClick={() => setUiPreferences({ coachCollapsed: !ui.coachHidden, guideCollapsed: false, focus: false })}>{ui.coachHidden ? '▸' : '▾'} Kanzler</button>
    <button data-ai-id="guide-focus" aria-pressed={ui.focus} aria-label="Fokus auf Bühne"
      title={ui.focus ? 'Vorherige Aufteilung wiederherstellen' : 'Bühne fokussieren – Guide und Kanzler bleiben links sichtbar'}
      onClick={() => setUiPreferences({ focus: !ui.focus })}>⛶ Fokus</button>
  </div>;
}
